import type { PriceProps } from '@/components/Price';
import { Price } from '@/components/Price';
import type { TaxedMoneyFragment } from '@/graphql/saleor/api';
import { checkIfVatIncluded } from '@/lib/regions';
import type { Maybe } from '@/lib/types';
import { useRegionProvider } from '@/providers/RegionProvider';

interface TaxedPriceProps
  extends Omit<PriceProps, 'price' | 'priceUndiscounted'> {
  channel?: string;
  className?: string;
  price: Maybe<Omit<TaxedMoneyFragment, '__typename'>>;
  priceUndiscounted?: Maybe<Omit<TaxedMoneyFragment, '__typename'>>;
}

export const TaxedPrice = ({
  channel,
  price,
  priceUndiscounted,
  ...props
}: TaxedPriceProps) => {
  const {
    country: { channelSlug: channelByLocale },
  } = useRegionProvider();
  let includeVAT = false;
  if (channel !== undefined) {
    includeVAT = checkIfVatIncluded(channel);
  } else {
    includeVAT = checkIfVatIncluded(channelByLocale);
  }
  if (includeVAT) {
    return (
      <Price
        data-test-id='TaxedPriceGross'
        price={price?.gross}
        priceUndiscounted={priceUndiscounted?.gross}
        {...props}
      />
    );
  }
  return (
    <Price
      data-test-id='TaxedPriceNet'
      price={price?.net}
      priceUndiscounted={priceUndiscounted?.net}
      {...props}
    />
  );
};
